import React from 'react';
import { ToolbarSwitch } from './ListViewToolbar/ListViewToolbar.style';

interface ListViewSetsToggleProps {
  /* Whether the member bookings of the sets are listed under the set they
     belong to */
  showChildren: boolean;
  onShowChildrenChange: (showChildren: boolean) => void;
}

/**
 * Whether the resources of the sets are listed individually under the set they
 * belong to. It does all the sets at once: every set can also be opened and
 * closed on its own, and this is what says how they all start out.
 *
 * The label names what flipping the switch does rather than the state it is
 * in — the knob already shows the state, and "collapse all"/"expand all" is
 * what the control reads as once the sets have been opened and closed
 * individually.
 *
 * It shapes how the bookings are presented, not which ones are shown, which is
 * why it sits with the view mode rather than with the filters.
 */
const ListViewSetsToggle = ({
  showChildren,
  onShowChildrenChange
}: ListViewSetsToggleProps) => (
  /* min-w-0 so the label below can be cut short: without it the switch keeps
     its full natural width and pushes the rest of the row aside */
  <div tw="min-w-0" data-test-list-view-sets-toggle>
    <ToolbarSwitch
      variant="switch"
      label={showChildren ? i18n('Collapse all sets') : i18n('Expand all sets')}
      defaultChecked={showChildren}
      onChange={() => onShowChildrenChange(!showChildren)}
    />
  </div>
);

export default ListViewSetsToggle;
